import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import { currentUser, currentUserACL } from 'selectors/auth.selector';
import MyFolioLogotype, {
  logotypeWidthWithHeight,
} from 'components/shared/MyFolio/MyFolioLogotype.react';

import MenuNonAuthenticated from './MenuNonAuthenticated.react';
import MenuAuthenticated from './MenuAuthenticated.react';

const logoHeight = 40; // Reverting back to 40px as this is the correct value
const logoWidth = logotypeWidthWithHeight(logoHeight);

const Root = styled('div')(() => {
  return {
    flexGrow: 1,
  };
});

const StyledAppBar = styled(AppBar)(({ theme }) => {
  return {
    // Branding green stays on the top nav; content surfaces stay light.
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  };
});

const Brand = styled('a')(() => {
  return {
    display: 'flex',
    alignItems: 'center',
  };
});

const Logotype = styled(MyFolioLogotype)(() => {
  return {
    height: `${logoHeight}px`,
    width: `${logoWidth}px`,
  };
});

const FlexibleSpace = styled('div')(() => {
  return {
    flexGrow: 1,
  };
});

const Header = () => {
  const user = useSelector(currentUser);
  const acl = useSelector(currentUserACL);

  return (
    <Root>
      <StyledAppBar id="app-bar" position="fixed">
        <Toolbar>
          <Brand href="/">
            <Logotype titleAccess="MyFolio" />
          </Brand>
          <FlexibleSpace />
          {user ? (
            <MenuAuthenticated currentUser={user} acl={acl} />
          ) : (
            <MenuNonAuthenticated />
          )}
        </Toolbar>
      </StyledAppBar>
    </Root>
  );
};

export default Header;
